"use client"

import { FADE_MASK_STYLE } from "@/utils/masonryMask"

interface JsonLineProps {
  lineNumber: number
  content: React.ReactNode
}

function JsonLine({ lineNumber, content }: JsonLineProps) {
  return (
    <div className="flex">
      <span className="w-8 text-right pr-4 text-fg-secondary select-none shrink-0">
        {lineNumber}
      </span>
      <span className="flex-1">{content}</span>
    </div>
  )
}

function JsonKey({ children }: { children: string }) {
  return <span className="text-blue-700 dark:text-blue-400">&quot;{children}&quot;</span>
}

function JsonString({ children }: { children: string }) {
  return <span className="text-amber-700 dark:text-amber-400">&quot;{children}&quot;</span>
}

function Comment({ children }: { children: string }) {
  return <span className="text-slate-600 dark:text-slate-500">{`// ${children}`}</span>
}

function Indent({ level }: { level: number }) {
  return <span>{" ".repeat(level * 2)}</span>
}

export function MCPConfigDemo() {
  return (
    <div
      className="relative border-t border-l border-solid border-border-default rounded-tl-xl bg-bg-default"
      style={{
        maxHeight: "400px",
        overflow: "hidden",
        ...FADE_MASK_STYLE,
      }}
    >
      {/* Content area */}
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center gap-2 px-3 py-1.5 bg-bg-surface rounded-lg border border-border-default">
            <span className="text-sm font-medium text-fg-default">mcp.json</span>
          </div>
          <span className="text-sm text-fg-secondary">Claude Desktop / Cursor Configuration</span>
        </div>

        {/* JSON Code Viewer */}
        <div className="font-mono text-sm leading-relaxed whitespace-pre">
          <JsonLine lineNumber={1} content={"{"} />
          <JsonLine
            lineNumber={2}
            content={
              <>
                <Indent level={1} />
                <JsonKey>mcpServers</JsonKey>: {"{"}
              </>
            }
          />
          <JsonLine
            lineNumber={3}
            content={
              <>
                <Indent level={2} />
                <JsonKey>tokenterminal</JsonKey>: {"{"}
              </>
            }
          />
          <JsonLine
            lineNumber={4}
            content={
              <>
                <Indent level={3} />
                <JsonKey>command</JsonKey>: <JsonString>npx</JsonString>,
              </>
            }
          />
          <JsonLine
            lineNumber={5}
            content={
              <>
                <Indent level={3} />
                <JsonKey>args</JsonKey>: [
              </>
            }
          />
          <JsonLine
            lineNumber={6}
            content={
              <>
                <Indent level={4} />
                <JsonString>@anthropic/token-terminal-mcp</JsonString>
              </>
            }
          />
          <JsonLine
            lineNumber={7}
            content={
              <>
                <Indent level={3} />
                ],
              </>
            }
          />
          <JsonLine
            lineNumber={8}
            content={
              <>
                <Indent level={3} />
                <JsonKey>env</JsonKey>: {"{"}
              </>
            }
          />
          <JsonLine
            lineNumber={9}
            content={
              <>
                <Indent level={4} />
                <JsonKey>TT_API_KEY</JsonKey>: <JsonString>your-api-key</JsonString>{" "}
                <Comment>Get from tokenterminal.com</Comment>
              </>
            }
          />
          <JsonLine
            lineNumber={10}
            content={
              <>
                <Indent level={3} />
                {"}"}
              </>
            }
          />
          <JsonLine
            lineNumber={11}
            content={
              <>
                <Indent level={2} />
                {"}"}
              </>
            }
          />
          <JsonLine
            lineNumber={12}
            content={
              <>
                <Indent level={1} />
                {"}"}
              </>
            }
          />
          <JsonLine lineNumber={13} content={"}"} />
        </div>
      </div>
    </div>
  )
}
